<template>
    <rkm-list
        :items="data.model.receitaMedica.medicamentos"
        hide-filters
    >
        <template v-slot="{ item }">
            <rkm-row class="justify-content-between pr-3">
                <rkm-col cols="auto">
                    <rkm-row>
                        <rkm-col>
                            <strong>{{ item.medicamento.nome }}</strong>
                            <template v-if="item.tipoAplicacao.id != null">
                                - {{ item.tipoAplicacao.nome }}
                            </template>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col v-if="!isTipoAplicacaoLivre(item)">
                            {{ item.quantidade.toString().replace('.', ',') }} {{ item.unidadeMedida.nome }}

                            <template v-if="!isTipoAplicacaoDoseUnica(item)">
                                <template v-if="!isTipoPosologiaTurno(item)">
                                    <template v-if="item.intervaloMedidaTempo.id === enums.medidaTempo.MINUTOS || item.intervaloMedidaTempo.id === enums.medidaTempo.HORAS">
                                        a cada {{ item.intervaloTempo }} {{ item.intervaloMedidaTempo.nome }}
                                    </template>

                                    <template v-else-if="item.intervaloMedidaTempo.id === enums.medidaTempo.DIAS || item.intervaloMedidaTempo.id === enums.medidaTempo.SEMANAS || item.intervaloMedidaTempo.id === enums.medidaTempo.MESES">
                                        {{ item.intervaloTempo }} vez(es) ao {{ item.intervaloMedidaTempo.nome }}
                                    </template>
                                </template>

                                <template v-else>
                                    pela {{ item.turno.nome }}
                                </template>

                                <template v-if="!isTipoAplicacaoDoseUnica(item)">
                                    durante {{ item.duranteQuantidade }} {{ item.duranteMedidaTempo.nome }}
                                </template>

                            </template>

                        </rkm-col>
                    </rkm-row>
                </rkm-col>

                <rkm-col cols="auto">
                    {{ item.viaAdministracao.nome }}
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="item.recomendacoes">
                <rkm-col>
                    <strong>
                        Recomendações:
                    </strong>
                    {{ item.recomendacoes }}
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="item.descricao">
                <rkm-col>
                    <strong>
                        Descrição:
                    </strong>
                    {{ item.descricao }}
                </rkm-col>
            </rkm-row>
        </template>

        <template v-slot:trailling="{ item }">
            <rkm-button
                :disabled="Number.isInteger(item.id)"
                @click.stop="handleEdit(item)"
                color="primary"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="Number.isInteger(item.id)"
                color="danger"
                @click.stop="handleDestroy(item)"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-list>
</template>

<script>
//Enums
import medidaTempo from '@/enums/cadastro/medidaTempo'
import tipoAplicacao from '@/enums/pronto-atendimento/receita/tipoAplicacao'
import tipoPosologia from '@/enums/pronto-atendimento/receita/tipoPosologia'

export default {
    data: () => ({
        enums: { medidaTempo, tipoAplicacao, tipoPosologia }
    }),
    methods: {
        handleDestroy(item) {

            const destroy = async () => {
                const index = this.data.model.receitaMedica.medicamentos
                    .findIndex(m => m.id === item.id)

                this.data.model.receitaMedica.medicamentos.splice(index, 1)
                this.$emit('delete')
            }

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        handleEdit(item) {

            this.$emit('edit', item)
        },
        isTipoAplicacaoUsoContinuo(item) {

            return item.tipoAplicacao.id === this.enums.tipoAplicacao.USO_CONTINUO
        },
        isTipoAplicacaoDoseUnica(item) {

            return item.tipoAplicacao.id === this.enums.tipoAplicacao.DOSE_UNICA
        },
        isTipoAplicacaoLivre(item) {

            return item.tipoAplicacao.id === this.enums.tipoAplicacao.LIVRE
        },
        isTipoPosologiaTurno(item) {

            return item.tipoPosologia === this.enums.tipoPosologia.TURNO
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
.rkm-list-group {
    padding: 15px;
}
</style>